import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { SmartState, DataDevice } from './types';
import { RootState } from '../types';

export const state: SmartState = {
  smart: undefined,
  dataDevices: Array<DataDevice>(),
};

const namespaced: boolean = true;

export const smart: Module<SmartState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
